import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DateUtil {

    constructor(
    ) { }

    isSameDay (date1: string | Date, date2: string | Date) {
        let date_1: Date
        let date_2: Date
        if (!this.isDate(date1)) 
            date_1 = new Date(date1) 
        else
            date_1 = date1 as Date
        if (!this.isDate(date2)) 
            date_2 = new Date(date2)
        else
            date_2 = date2 as Date        
        if(!date_1 || !date_2) return false
        
        return      date_1.getFullYear  () == date_2.getFullYear  ()
                &&  date_1.getMonth     () == date_2.getMonth     ()
                &&  date_1.getDate      () == date_2.getDate      ()
    }

    isPrevious (date1: string | Date, date2: string | Date) {
        let date_1: Date
        let date_2: Date
        if (!this.isDate(date1)) 
            date_1 = new Date(date1) 
        else
            date_1 = date1 as Date
        if (!this.isDate(date2)) 
            date_2 = new Date(date2)
        else
            date_2 = date2 as Date

        if(!date_1 || !date_2) return false
            
        return date_1 < date_2
        
        // return      date_1.getFullYear  () <= date_2.getFullYear  ()
        //         &&  date_1.getMonth     () <= date_2.getMonth     ()
        //         &&  date_1.getDate      () <  date_2.getDate      ()
        
    }

    isNext (date1: string | Date, date2: string | Date) {
        let date_1: Date
        let date_2: Date
        if (!this.isDate(date1)) 
            date_1 = new Date(date1) 
        else
            date_1 = date1 as Date
        if (!this.isDate(date2)) 
            date_2 = new Date(date2)
        else
            date_2 = date2 as Date        
        
        if(!date_1 || !date_2) return false
        
        return date_1 > date_2

        // return      date_1.getFullYear  () >= date_2.getFullYear  ()
        //         &&  date_1.getMonth     () >= date_2.getMonth     ()
        //         &&  date_1.getDate      () >  date_2.getDate      ()
    }


    isToday (date: string | Date ) {
        let date_1: Date
        if (!this.isDate(date)) 
            date_1 = new Date(date)
        else
            date_1 = date as Date

        return this.isSameDay(date_1, new Date())
    }

    addDay (date: string | Date, summedDays: number) {
        let date_1: Date
        if (!this.isDate(date)) 
            date_1 = new Date(date)
        else
            date_1 = date as Date

        if(!date_1) return undefined
        date_1.setDate( date_1.getDate() + summedDays)
        return date_1
    }

    getToday()
    {
        return new Date()
    }

    isDate( date: any){
        return date instanceof Date
    }

    toFormat( date: any , format: string, locale ?: string){
        try{
            if (!this.isDate(date)) 
            date = new Date(date) 
            const datepipe: DatePipe = new DatePipe( locale ? locale : "en" )
            return datepipe.transform(date, format)
        }catch(error){
            return undefined
        }
    }
}
